import { render, staticRenderFns } from "./NavMobile.vue?vue&type=template&id=960f1ea8&"
import script from "./NavMobile.vue?vue&type=script&lang=js&"
export * from "./NavMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('960f1ea8', component.options)
    } else {
      api.reload('960f1ea8', component.options)
    }
    module.hot.accept("./NavMobile.vue?vue&type=template&id=960f1ea8&", function () {
      api.rerender('960f1ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/nav/NavMobile.vue"
export default component.exports